import React from "react";
import RoomsSection from "../components/Rooms";

const Rooms = () => {
  return (
    <div>
      <RoomsSection />
    </div>
  );
};

export default Rooms;
